<template>
  <div>
    <div class="login-container reset-pass-container dark">
      <div class="login-wrapper">

        <!-- reset_password:start -->
        <div class="m-box" v-show="(state == 'reset_password')">
          <section class="login-content">

            <h1 class="mb-4">{{$t("resetpassword.title")}}</h1>
            <p>{{$t("resetpassword.detail")}}</p>

            <v-form class="mb-2" v-model="resetpassword_valid">
              <v-text-field
                class="mb-2"
                color="white"
                :label="$t('user-params.username')"
                v-model="username"
                :rules="usernameRules"
                required
              ></v-text-field>
              <v-text-field style="display:none;"></v-text-field><!-- input 1つだとenter時リロードされるので対策-->
              <v-btn
                class="mb-3 white--text"
                :class="resetpassword_valid?'blue':'grey'"
                @click="resetPassword"
                :disabled="!resetpassword_valid || submitted"
              >
                {{$t("login.next")}}
              </v-btn>
            </v-form>


          </section>
        </div>
        <!-- reset_password:end -->

      <!-- confirm:start -->
      <div class="m-box" v-show="(state == 'confirm')">
        <div class="confirm-box login-content">
          <p class="confirm-lead">{{$t("resetpassword.entercode")}}</p>
          <p class="confirm-msg">
            {{$t("resetpassword.codedetail")}}
          </p>
            <v-form class="mb-2"  v-model="confirm_valid">
              <v-text-field color="white"
              :label="$t('resetpassword.entercode')"
              v-model="confirmationCode"
              :rules="codeRules"
              type="password"
              required
              >
              </v-text-field>
              <v-text-field color="white"
              :label="$t('resetpassword.newpassword')"
              v-model="newPassword"
              :rules="passwordRules"
              required
              :append-icon="passwordVisible? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (passwordVisible = !passwordVisible)"
              :type="passwordVisible ? 'text':'password'"
              autocomplete="new-password"
              >
              </v-text-field>
              <v-btn
                class="mb-3"
                :class="confirm_valid?'blue':'grey'"
                color="blue"
                dark
                @click="confirmResetPassword"
                :disabled="!confirm_valid || submitted"
              >
                {{$t("resetpassword.confirm")}}
              </v-btn>
            </v-form>
          <p><a href="#" v-on:click="resendConfirmationCode">{{$t("resetpassword.resendcode")}}</a></p>
        </div>
      </div>
      <!-- confirm:end -->

      <div v-show="errorMessage">
        <div class="alert alert-danger alert-dismissible fade in" role="alert">
          <button class="close" type="button" v-on:click="clearErrorMessage" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          {{ errorMessage }}
        </div>
      </div>

    <login-footer />
    </div>
  </div>
  </div>
</template>

<script>
import cognito from '@/utils/cognito.js'
import LoginFooter from '@/pages/LoginFooter'

export default {
  components: {
    LoginFooter
  },
  data () {
    return {
      resetpassword_valid: true,
      confirm_valid: true,
      passwordVisible: false,
      submitted: false,  // submitフラグ
      state: 'reset_password', // or confirm
      username: '',
      confirmationCode: '',
      newPassword: '',
      confirmNewPassword: '',
      errorMessage: '',
      // 追加
      name: '',
      usernameRules: [
        (v) => !!v || this.$t('login.vali-username-blank')
      ],
      codeRules: [
        (v) => !!v || this.$t('resetpassword.vali-code-blank')
      ],
      passwordRules: [
        (v) => !!v || this.$t('resetpassword.vali-pass-blank'),
        (v) => /[0-9]+/.test(v) && /[a-z]+/.test(v) || this.$t('resetpassword.vali-pass-number'),
        (v) => v.length >= 8 || this.$t('resetpassword.vali-pass-length')
      ]
      // ここまで
    }
  },
  methods: {
    resetPassword () {
      this.submitted = true // ボタン無効化
      this.username = this.username.trim()
      this.clearErrorMessage()
      const self = this
      cognito.forgotPassword(self.username)
        .then(() => {
          self.state = 'confirm'
          self.submitted = false // ボタン有効化
        })
        .catch(err => {
          self.errorMessage = err.message
          self.submitted = false // ボタン有効化
        })
    },
    confirmResetPassword () {
      this.submitted = true // ボタン無効化
      this.clearErrorMessage()
      const self = this
      cognito.confirmResetPassword(self.username, self.confirmationCode, self.newPassword)
        .then(() => {
          alert('Success')
          self.submitted = false // ボタン有効化
          window.location.href = '/dashboard/'
        })
        .catch(err => {
          self.errorMessage = err.message
          self.submitted = false // ボタン有効化
        })
    },
    resendConfirmationCode () {
      const self = this
      // 再送もこれでok
      cognito.forgotPassword(self.username)
        .then(() => {
          alert('Success')
        })
        .catch(err => {
          alert('Fail:' + err.message)
        })
    },
    clearErrorMessage () {
      this.errorMessage = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?70ed7a22